import { render, staticRenderFns } from "./PlanData.vue?vue&type=template&id=38c95028"
import script from "./PlanData.vue?vue&type=script&lang=js"
export * from "./PlanData.vue?vue&type=script&lang=js"
import style0 from "./PlanData.vue?vue&type=style&index=0&id=38c95028&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports